const endpoints = {
  auth: {
    login: "/auth/login",
  },

  dashboard: {
    base: "/dashboard", // GET (index)
  },

  venue: {
    base: "/venue",                 // GET (index), POST (store)
    detail: (id) => `/venue/${id}`, // GET (show), PUT (update), DELETE (destroy)
  },

  user: {
    base: "/user",                  // GET (index), POST (store)
    detail: (id) => `/user/${id}`,  // GET (show), PUT (update), DELETE (destroy)
    changePassword: (id) => `/user/${id}/change-password`, // POST
  },

  log: {
    base: "/log",                   // GET (index)
  },

  device: {
    base: "/device",                   // GET (index), POST (store)
    detail: (id) => `/device/${id}`,   // GET (show + sync), PUT (update), DELETE (destroy)

    switch: "/device/switch",          // POST { ids: [], state: boolean }
    selections: "/device/selections",  // GET
  },

  deviceSchedule: {
    base: "/device-schedule",                 // GET, POST
    detail: (id) => `/device-schedule/${id}`, // GET, PUT, DELETE
  },

  reservation: {
    base: "/reservations",                 // GET (index), POST (store)
    detail: (id) => `/reservations/${id}`, // GET (show), PUT (update), DELETE (destroy)
    resendNotification: "/reservations/resend-notification",
    archived: "/reservations/archived",
  },

  settings: {
    base: "/setting", // GET (index), PUT (update)
    upload: "/setting/upload", // POST (image upload)
    deleteReceiptLogo: "/setting/receipt/logo", // DELETE (remove receipt logo)
  },

  transactions: {
    base: "/transactions",                 // GET (index), POST (store)
    detail: (id) => `/transactions/${id}`, // GET (show), PUT (update)
    query: "/transactions/query",
  },

  receipts: {
    base: "/receipts",
    detail: (id) => `/receipts/${id}`,
    sendEmail: (id) => `/receipts/${id}/send-email`,
    regenerate: (id) => `/receipts/${id}/regenerate`,
  },
  report: {
    base: "/report", // GET (index)

    roster: "/report/roster",
    reservations: "/report/reservations",
    slips: "/report/slips",
    transactions: "/report/transactions",
    receipts: "/report/receipts",

    receiptsBatch: "/report/receipts/batch",

    detail: (id) => `/report/${id}`, // DELETE (destroy)
  },
};

export default endpoints;